/*eslint-disable*/
import React, { Fragment, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import UploadFileComponent from "./uploadFileComponent";
import AddNewFileButton from "./addNewFileButton";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  divMain: {
    flexGrow: 1,
  },
  divFile: {
    width: "200px",
    height: "200px",
    borderRadius: "8px",
    backgroundColor: "#2d3034",
  },
  icon: {
    width: "40px",
    height: "40px",
    color: "white",
    marginBottom: "20px",
  },
  textFieldLetter: {
    fontFamily: "Roboto",
    fontSize: 17,
    fontWeight: "bold",
    textAlign: "left",
    color: "#cdcece",
  },

  trackVertical: {
    height: "95%",
    right: 0,
    width: "10px !important",
  },

  thumbVertical: {
    backgroundColor: "#2d3034",
    height: "100%",
    right: 0,
    width: "8px !important",
    borderRadius: "8px",
  },
}));

export default function InfoFiles(props) {
  const classes = useStyles();
  const { files } = useSelector((state) => state.file);

  const filesFilter = [
    ...new Map(files.map((item) => [item["name"], item])).values(),
  ];

  const predefinedDocuments = [
    "Examen médico",
    "Antidoping",
    "Carta no antecendes penales",
    "Seguro",
  ];

  function difference(a1, a2) {
    return a1.filter((o1) => a2.filter((o2) => o2 === o1.name).length === 0);
  }

  return (
    <Fragment>
      <div className={classes.divMain}>
        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          style={{
            paddingRight: 38,
            marginBottom: 25,
          }}
        >
          <AddNewFileButton />
        </Grid>

        <Grid
          container
          spacing={4}
          style={{ paddingRight: 38, marginBottom: 20 }}
        >
          {predefinedDocuments.length == 0 && files.length == 0 && (
            <Grid
              container
              direction="column"
              alignContent="center"
              justifyContent="center"
              item
              xs={12}
              style={{ width: "100%", height: "100%" }}
            >
              <Lottie options={defaultOptions} height={237} width={238} />
              <Typography
                style={{
                  fontFamily: "Roboto",
                  fontSize: 26,
                  textAlign: "center",
                  color: "#c1c1c1",
                  fontWeight: 500,
                }}
              >
                Sin expediente de archivos
              </Typography>
            </Grid>
          )}

          {predefinedDocuments.map((predefined, index) => (
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3} key={index}>
              <UploadFileComponent tag={predefined} />
            </Grid>
          ))}

          {files &&
            difference(filesFilter, predefinedDocuments).map(
              (document, index) => (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  xl={3}
                  key={index + predefinedDocuments.length}
                >
                  <UploadFileComponent tag={document.name} />
                </Grid>
              )
            )}
        </Grid>
      </div>
    </Fragment>
  );
}
